import { Box, Container } from "@mui/material";
import { DocumentationListTable } from "./pages/DocumentationListTable";
import { DocumentationToolbar } from "./pages/DocumentationToolbar";

export function DocumentationUICard() {
  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 4,
        }}
      >
        <Container maxWidth={false}>
          <DocumentationToolbar />
          <Box sx={{ mt: 3 }}>
            <DocumentationListTable />
          </Box>
        </Container>
      </Box>
    </>
  );
}
